module.exports = __webpack_public_path__ + "static/media/mongodb_logo.686de666.svg";